// UserList.js
import React, { useContext } from 'react';
import style from './UserList.module.css';

// Przykładowy obrazek (zastąp własnym)
import userOnline from 'assets/user_offline.svg'; 
import { useSocket } from 'context/SocketContext';
import DecodeToken from 'pages/Login/DecodeToken';
import { AppContext } from 'context/AppContext';


const OnlineIcon = ({status}) => {
  if(status=="Aktywny") {
  return( <span className={style.onlineIcon} title="Online" />);
};
}


const UserList = () => {
   const appcontext = useContext(AppContext);
      
      const pokazUzytkownikowOnline = appcontext.pokazUzytkownikowOnline;
      const setPokazUzytkownikowOnline = appcontext.setPokazUzytkownikowOnline;
   const { socket, isConnected, isAuthenticated, updateAuthStatus,usersIO } = useSocket()
  return (
    // Kontener główny, który zajmie 100% szerokości rodzica
    <div className={style.userListContainer}>
      {/* Używamy CSS Grid, aby umieścić użytkowników w jednym rzędzie 
          i automatycznie dopasować ich liczbę oraz rozmiar */}
      <div className={style.usersGrid}>
        {usersIO
          .filter(
            (user) =>{
// 1. Pobieramy ID z tokena
  const loggedInUserId = DecodeToken(sessionStorage.getItem("token"))?.id;

  // 2. Podstawowe filtrowanie (zawsze aktywne)
  const isNotExcluded = user.userId !== 10 && user.userId !== 60;

  // 3. Warunek specjalny: jeśli ja mam ID 10, to dodatkowo odfiltruj użytkownika o ID 4
  if (loggedInUserId === 10) {
    return isNotExcluded && user.userId !== 4;
  }

  // W przeciwnym razie stosuj tylko standardowe filtry
  return isNotExcluded;
            }
          
          )
          
.filter((user, index, self) => self.findIndex((u) => u.userId === user.userId) === index) // bez duplikatów zalogowanych
          .map((user, i) => (
            // Pojedynczy element użytkownika
            <div
              title={`${user.imie} ${user.nazwisko}\nZalogowano: ${user.zalogowany}\nOstatnio aktywny: ${user.ostatnia_aktywnosc}\nSocket ID: ${user.socketId}`}
              key={user.socketId || i}
              className={
                user.status == "Aktywny" ? style.userCardActive : style.userCard
              }
            >
              <OnlineIcon status={user.status} />
    
              <img
                className={style.userIcon}
                src={user.imageUrl || userOnline} // Użyj obrazka z danych lub domyślnego
                alt={`Avatar użytkownika ${user.imie}`}
              />

        
              <span className={style.userName}>{user.imie} </span>

         
              <span className={style.userSurname}>{user.nazwisko}</span>


            </div>
          ))}

      </div>
    </div>
  );
};

export default UserList;